/* zeroLabs: Bewertungs-Karussell von Judge.me als Reihe zum Wischen.
   Gilt überall, außer im Labor mit html[data-zl-bw="heute"] (Regler auf der Startseite zeigt dort die alte Fassung). Live seit 11.10.2026.
   Gestaltung: assets/zl-bewertungen.css. Was dieses Skript tut:
   - Die Pfeile wandern in den Kopf, rechts neben Überschrift und Zahl.
   - Der Browser scrollt die Reihe selbst. Judge.me bekommt Berührungen in der Reihe nicht mehr, sonst würde es die Reihe
     zusätzlich selbst verschieben. Ein Klick auf eine Karte öffnet weiter die ganze Bewertung.
   - Die Pfeile blättern um so viele Karten, wie ganz zu sehen sind, und sind am Anfang und am Ende blass.
   Die Texte der Kunden bleiben unberührt. */
(() => {
  const html = document.documentElement;
  const aktiv = () => html.dataset.zlBw !== 'heute';
  const ruhig = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const einrichten = (wrapper) => {
    if (wrapper.dataset.zlBwFertig) return;
    const kopf = wrapper.querySelector('.jdgm-carousel-title-and-link');
    const pfeile = wrapper.querySelector('.jdgm-carousel__arrows');
    const reihe = wrapper.querySelector('.jdgm-carousel__item-container');
    if (!kopf || !pfeile || !reihe) return;
    wrapper.dataset.zlBwFertig = '1';
    const links = pfeile.querySelector('.jdgm-carousel__left-arrow');
    const rechts = pfeile.querySelector('.jdgm-carousel__right-arrow');
    const zuhause = pfeile.parentElement;

    const stellen = () => {
      if (!aktiv()) return;
      const max = Math.max(0, reihe.scrollWidth - reihe.clientWidth);
      if (links) links.classList.toggle('ist-am-ende', reihe.scrollLeft <= 1);
      if (rechts) rechts.classList.toggle('ist-am-ende', reihe.scrollLeft >= max - 1);
    };
    const schritt = () => {
      const karte = reihe.querySelector('.jdgm-carousel-item');
      if (!karte) return reihe.clientWidth;
      const gap = parseFloat(getComputedStyle(karte.parentElement).columnGap) || 0;
      const breite = karte.getBoundingClientRect().width + gap;
      const sichtbar = Math.max(1, Math.floor((reihe.clientWidth + gap) / breite));
      return breite * sichtbar;
    };
    const blaettern = (richtung) => {
      reihe.scrollBy({ left: richtung * schritt(), behavior: ruhig() ? 'auto' : 'smooth' });
    };

    const anwenden = () => {
      if (aktiv()) {
        if (pfeile.parentElement !== kopf) kopf.appendChild(pfeile);
        reihe.scrollLeft = 0;
        stellen();
      } else if (pfeile.parentElement !== zuhause) {
        zuhause.appendChild(pfeile);
      }
    };

    // Pfeile: vor Judge.me abfangen, damit nur der Browser scrollt
    [[links, -1], [rechts, 1]].forEach(([el, richtung]) => {
      if (!el) return;
      const los = (e) => {
        if (!aktiv()) return;
        if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        e.stopImmediatePropagation();
        blaettern(richtung);
      };
      el.addEventListener('click', los, true);
      el.addEventListener('keydown', los, true);
    });
    // Berührungen und Ziehen in der Reihe gehören dem Browser, nicht dem Karussell von Judge.me
    ['touchstart', 'touchmove', 'touchend', 'pointerdown', 'pointermove', 'pointerup', 'mousedown', 'mousemove', 'mouseup'].forEach((typ) => {
      reihe.addEventListener(typ, (e) => { if (aktiv()) e.stopPropagation(); }, { capture: true, passive: true });
    });
    reihe.addEventListener('scroll', stellen, { passive: true });
    window.addEventListener('resize', stellen, { passive: true });
    // Die Breite der Reihe steht erst, wenn Gestaltung und Fotos da sind: dann die Pfeile neu stellen
    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(() => stellen());
      ro.observe(reihe);
      const inhalt = reihe.firstElementChild;
      if (inhalt) ro.observe(inhalt);
    }
    window.addEventListener('load', stellen);
    new MutationObserver(anwenden).observe(html, { attributes: true, attributeFilter: ['data-zl-bw'] });
    anwenden();
    // Überschrift und Zahl stehen optisch auf der Kante (assets/zl-custom.js, Optische Kante), auch wenn Judge.me spät baut
    if (window.zlKante) window.zlKante(wrapper);

    // Der Kopf tritt einmal auf wie jeder Kapitelkopf, die Pfeile stehen (Moritz, 12.10.2026). Im Labor mit html[data-zl-bw-auftritt="aus"] zum Vergleich ohne.
    // Die Karten kommen danach Karte für Karte, jede als Ganzes mit Foto. Karten außerhalb des Bildes stehen gleich da,
    // wer wischt, wartet auf nichts. Mechanik in assets/zl-custom.js.
    const auftritt = () => {
      if (html.dataset.zlBwAuftritt === 'aus' || !aktiv() || wrapper.dataset.zlBwAuftritt) return;
      // Erst, wenn Judge.me die Reihe sichtbar gemacht hat: vorher hat sie keine Größe, und die Lage der Karten stimmt nicht
      if (!reihe.getBoundingClientRect().width || !(reihe.querySelector('.jdgm-carousel-item') || {}).offsetWidth) { setTimeout(auftritt, 100); return; } // token-ok: kurz warten
      wrapper.dataset.zlBwAuftritt = '1';
      // Steht die Reihe schon beim Aufbau im Bild (etwa auf Presse und Bewertungen im ersten Bildschirm), tritt nichts auf:
      // Der erste Bildschirm hat keinen Auftritt, die Karten stehen gleich da
      const linie = parseFloat(getComputedStyle(html).getPropertyValue('--zl-auftritt-start')) || 1;
      if (kopf.getBoundingClientRect().top < window.innerHeight * linie && window.scrollY < window.innerHeight) return;
      kopf.setAttribute('data-zl-auftritt', '');
      pfeile.setAttribute('data-zl-auftritt-bleibt', '');
      wrapper.dispatchEvent(new CustomEvent('zl:auftritt', { bubbles: true }));
      const liste = reihe.querySelector('.jdgm-carousel__item-wrapper');
      if (!liste) return;
      // Fotos der Karten, die auftreten, laden sofort, nicht erst kurz vor dem Bild (Judge.me lädt sie sonst spät nach).
      // Die Karten treten erst auf, wenn ihre Fotos da sind, höchstens 1,5 s gewartet: Die Karte kommt mit ihrem Bild.
      const fotos = [];
      liste.querySelectorAll(':scope > .jdgm-carousel-item').forEach((karte) => {
        if (karte.getBoundingClientRect().left >= window.innerWidth) { karte.setAttribute('data-zl-auftritt-bleibt', ''); return; }
        karte.querySelectorAll('img').forEach((bild) => {
          if (!bild.getAttribute('src') && bild.dataset.src) bild.setAttribute('src', bild.dataset.src);
          if (bild.decode) fotos.push(bild.decode().catch(() => {}));
        });
      });
      liste.setAttribute('data-zl-auftritt', '');
      liste.setAttribute('data-zl-auftritt-js', ''); // Karten in der Reihe bewegt das Skript, Safari überspringt dort den Übergang
      Promise.race([Promise.all(fotos), new Promise((fertig) => { setTimeout(fertig, 1500); })]) // token-ok: höchstens 1,5 s auf Fotos warten
        .then(() => reihe.dispatchEvent(new CustomEvent('zl:auftritt', { bubbles: true })));
    };
    // Der Regler im Labor setzt seine Wahl manchmal erst, nachdem Judge.me gebaut hat
    new MutationObserver(auftritt).observe(html, { attributes: true, attributeFilter: ['data-zl-bw-auftritt'] });
    auftritt();
  };

  // Judge.me baut das Karussell erst nach dem Laden der Seite
  const suchen = () => document.querySelectorAll('.jdgm-carousel-wrapper').forEach((w) => { if (w.querySelector('.jdgm-carousel--done, .jdgm-carousel-item')) einrichten(w); });
  const start = () => {
    suchen();
    const mo = new MutationObserver(suchen);
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => mo.disconnect(), 20000); // token-ok: nach 20 s hat Judge.me längst gebaut
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
